import useChatWidget from '../hooks/useChatWidget'
import { ContactUs } from './shared'

interface ContactUsWrapperProps {
  suggestion?: string
}

export const ContactUsWrapper = ({ suggestion = '' }: ContactUsWrapperProps) => {
  const { openChatWidget } = useChatWidget()

  return (
    <div className="LoNotSensitive">
      <ContactUs onClick={() => openChatWidget('', suggestion)} />
    </div>
  )
}
